// extracted by mini-css-extract-plugin
module.exports = {"root":"IEDeprecationBanner_root__NiT8x","text":"IEDeprecationBanner_text__9f9p_","link":"IEDeprecationBanner_link__kolKK"};